export enum TypeCards {
  ADMIN_LOCATION_CREATE,
  ADMIN_LOCATION_UPDATE,

  ADMIN_ROUTER_UPDATE,

  ADMIN_ADVERTISER_UPDATE,

  ADMIN_ADVERTISING_CAMPAIGN_CREATE,
  ADMIN_FRANCHISE_UPDATE,
  ADMIN_FRANCHISED_CREATE,
  FRANCHISE_FRANCHISED_UPDATE
}
